module.exports = __webpack_public_path__ + "static/media/Shelves_nolabels.8dfd3390.png";